import { render, staticRenderFns } from "./CustomerProducts.vue?vue&type=template&id=2d717bba&"
import script from "./CustomerProducts.vue?vue&type=script&lang=js&"
export * from "./CustomerProducts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProducts.vue?vue&type=style&index=0&id=2d717bba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports